/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { domainsListRootMcpServers } from "../funcs/domainsListRootMcpServers.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListRootMcpServersResponseBody } from "../models/components/listrootmcpserversresponsebody.js";
import {
  ListRootMcpServersRequest,
  ListRootMcpServersSecurity,
} from "../models/operations/listrootmcpservers.js";
import { unwrapAsync } from "../types/fp.js";
export type RootMcpServersQueryData = ListRootMcpServersResponseBody;

export function prefetchRootMcpServers(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRootMcpServersRequest | undefined,
  security?: ListRootMcpServersSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRootMcpServersQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRootMcpServersQuery(
  client$: GramCore,
  request?: ListRootMcpServersRequest | undefined,
  security?: ListRootMcpServersSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<RootMcpServersQueryData>;
} {
  return {
    queryKey: queryKeyRootMcpServers({ gramSession: request?.gramSession }),
    queryFn: async function rootMcpServersQueryFn(
      ctx,
    ): Promise<RootMcpServersQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(domainsListRootMcpServers(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRootMcpServers(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "domains", "listRootMcpServers", parameters];
}
